import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LoadingErrorBlockComponent } from '@app/components/loading-error-block/loading-error-block.component';
import { HeadMetaComponent } from '@app/components/ui.component';
import { UserWithRelationships } from '@app/models/user.interface';
import { AuthService } from '@app/services/auth.service';
import { UserHelperService } from '@app/services/helpers/user-helper.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faCirclePlus,
  faArrowLeft
 } from '@fortawesome/free-solid-svg-icons';
import { LetDirective } from '@ngrx/component';
import { Observable } from 'rxjs';
import { HelpButtonComponent } from "@app/components/help-button/help-button.component";
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-users',
    imports: [
        HeadMetaComponent,
        LetDirective,
        LoadingErrorBlockComponent,
        FontAwesomeModule,
        RouterModule,
        ReactiveFormsModule,
        HelpButtonComponent
    ],
    templateUrl: './listing.page.html',
    styleUrl: './listing.page.scss'
})
export class UsersPage {
  public title = 'Users';
  searchForm: FormGroup = new FormGroup({
    status: new FormControl<string>('active'),
  });
  users$: Observable<UserWithRelationships[]>;

  faCirclePlus = faCirclePlus;
  faArrowLeft = faArrowLeft;

  constructor(
    private userHelper: UserHelperService,
    public auth: AuthService,
  ) {
    this.users$ = this.userHelper.getAll();
    this.submit();
  }

  public submit() {
    const form = this.searchForm.value;
    if (form) {
      this.users$ = this.userHelper.search(form.status);
    }
  }

  /**
   * Format an array of items with overflow truncation
   * @param items Array of strings to format
   * @param limit Maximum number of items to show before truncating
   * @returns Formatted string like "Item1, Item2, + 3 more"
   */
  formatWithOverflow(items: string[] | undefined, limit: number): string {
    if (!items || items.length === 0) {
      return '-';
    }

    if (items.length <= limit) {
      return items.join(', ');
    }

    const visible = items.slice(0, limit);
    const remaining = items.length - limit;
    return `${visible.join(', ')}, + ${remaining} more`;
  }
}
